import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import { useActionDialogContext } from '../../Context/ActionDialogContext';

function HireDialogHeader(): React.JSX.Element {
    const { selectedCandidates } = useActionDialogContext();
    const { name } = selectedCandidates[0];

    return (
        <div className="text-foreground text-xl font-bold">
            <span>{`${UIStrings.HaveYouHired} `}</span>
            <span>{`${name}?`}</span>
        </div>
    );
}

export default HireDialogHeader;
